module.exports = __webpack_public_path__ + "static/media/1.06e008fa.png";